<style lang="sass" scoped>
.group-list-item
  display: flex
  justify-content: space-between
.invite-btn
  display: flex
  align-self: center
</style>

<template lang="pug">
div.data-section
  div.space-btw
    h3 GRUPOS
    v-btn(icon @click='addGroupDialog = true')
      v-icon mdi-plus
  div.text-center.my-4(v-if='loading')
      v-progress-circular(indeterminate)
  div
    div(v-for='(group, i) in groups' :key='i')
      div.group-list-item.py-2
        div
          div
            span.font-weight-bold.mr-2 Id&nbsp;
            span {{ group.id }}
          div(style='display: inline-flex')
            span.font-weight-bold.mr-2(style='align-self: center') Nome&nbsp;
            v-text-field(dense v-model='group.name' :disabled='!updateName')
            v-btn(v-if='!updateName' icon @click='updateName = true' style='align-self: center')
              v-icon mdi-pencil
            div(v-if='updateName' style='align-self: center')
              v-btn(icon @click='update(group.id, group.name)')
                v-icon(color='green') mdi-check
              v-btn(icon @click='updateName = false')
                v-icon mdi-close
          div
            span.font-weight-bold.mr-2 Tipo&nbsp;
            span {{ group.group_type_name }}
        div.invite-btn
          v-btn(text @click='openInviteDialog(group.id, group.name)') Convidar usuário
        div
          v-btn(text @click='openSheetDialog(group.id, group.name)') Importar pessoas
      v-divider(v-if='i < groups.length - 1')
  v-dialog(v-model='addGroupDialog' max-width='500px')
    v-card
      v-card-title
        | Adicionar Grupo
        v-spacer
        v-btn(icon @click='addGroupDialog = false')
          v-icon mdi-close
      v-card-text
        v-form(ref='form')
          v-select(v-model='newGroup.type' :items='types' label='Tipo do grupo')
          v-text-field(v-model='newGroup.name' label='Nome do grupo')
      v-card-actions
        v-btn(@click='$refs.form.reset()' :disabled='addingGroup') Limpar
        v-spacer
        v-btn(@click='add()' :loading='addingGroup') Salvar
  v-dialog(v-model='importSheetDialog', max-width='500px')
    v-card
      v-card-title
        | Importar planilha de pessoas
        v-spacer
        v-card-text
          input(v-if='update' type='file' @change='onFilePicked')
        v-spacer
        v-card-actions
          v-btn(@click='sendSheet()') Enviar
        div
          div.text-center(v-if='loadingSend')
            v-progress-circular(indeterminate)
  v-dialog(v-model='inviteUserDialog' max-width='500px')
    v-card
      v-card-title
        | Convidar Usuário
        v-spacer
        v-btn(icon @click='inviteUserDialog = false')
          v-icon mdi-close
      v-card-text
        div(style='font-size: 16px') Convidar usuário para o grupo: {{currentGroup.name}}
        v-form(ref='inviteForm')
          v-text-field(v-model='userInvited' label='E-mail do usuário a ser convidado')
      v-card-actions
        v-btn(@click='inviteUser()') Convidar
  v-snackbar(v-model='snackbar')
    div Nome de grupo atualizado!
    v-btn(icon @click='snackbar = false')
      v-icon mdi-close
  v-snackbar(v-model='addGroupSnackbar')
    div Grupo adicionado!
    v-btn(icon @click='addGroupSnackbar = false')
      v-icon mdi-close
  v-snackbar(v-model='inviteUserSnackbar')
    div Convite enviado!
    v-btn(icon @click='inviteUserSnackbar = false')
      v-icon mdi-close
</template>

<script>
import utils from '../../utils/requests'
import readXlsxFile from 'read-excel-file'

export default {
  props: {
    id: String
  },
  data () {
    return {
      snackbar: false,
      addGroupSnackbar: false,
      groups: [],
      loading: true,
      updateName: false,
      addGroupDialog: false,
      types: ['Comissários', 'Fornecedores', 'Funcionários'],
      newGroup: {
        name: '',
        type: ''
      },
      addingGroup: false,
      userInvited: '',
      inviteUserDialog: false,
      importSheetDialog: false,
      currentGroup: {
        name: '',
        id: ''
      },
      inviteUserSnackbar: false,
      peopleDataToSend: null,
      loadingSend: false,
    }
  },
  mounted () {
    utils.postAPI('/event/list_event_groups', { id: this.id }).then(res => {
      this.groups = res.groups
      this.loading = false
    })
  },
  methods: {
    update (id, newName) {
      utils.postAPI('/event/update_group', { group_id: id, name: newName }).then(res => {
        console.log(res)
        this.snackbar = true
        this.updateName = false
      })
    },
    add () {
      this.addingGroup = true

      let url

      if (this.newGroup.type === 'Fornecedores') {
        url = '/event/add_supplier_group'
      } else if (this.newGroup.type === 'Funcionários') {
        url = '/event/add_employee_group'
      } else if (this.newGroup.type === 'Comissários') {
        url = '/event/add_commissioner_group'
      }

      const data = {
        'event_id': this.id,
        'group_name': this.newGroup.name
      }

      console.log(url)
      console.log(JSON.stringify(data))

      utils.postAPI(url, data).then(res => {
        console.log(res)
        this.addingGroup = false
        this.$refs.form.reset()
        this.addGroupDialog = false
        this.addGroupSnackbar = true
        window.location.reload()
      })
    },
    openInviteDialog (id, name) {
      this.currentGroup.name = name
      this.currentGroup.id = id
      this.inviteUserDialog = true
    },
    inviteUser () {
      const data = {
        'email': this.userInvited,
        'group_id': this.currentGroup.id
      }
      utils.postAPI('/users/invite_new_user', data).then(res => {
        console.log(res)
        this.inviteUserDialog = false
        this.inviteUserSnackbar = true
        this.$refs.inviteForm.reset()
      })
    },
    openSheetDialog (id, name) {
      this.currentGroup.name = name
      this.currentGroup.id = id
      this.importSheetDialog = true
    },
    onFilePicked (event) {
      const xlsxfile = event.target.files ? event.target.files[0] : null
      var people = []
      readXlsxFile(xlsxfile).then((rows) => {
        for (var i = 1; i < rows.length; i++){
          const personRow = rows[i] 
          const person = {
            'group_id': this.currentGroup.id,
            'person': {
              'code': personRow[0],
              'name': personRow[1],
              'email': personRow[2],
              'phone': personRow[3],
              'company': personRow[4],
              'role': personRow[5],
              'address': personRow[6],
              'address_number': personRow[7],
              'address_addon': personRow[8],
              'neighborhood': personRow[9],
              'city': personRow[10],
              'state': personRow[11],
              'zip_code': personRow[12],
              'cpf': personRow[13],
              'creation': new Date().toISOString(),
            }
          }
          people.push(person)
        }
        console.log({'people': people})
        this.peopleDataToSend = {'people': people}
      })
    },
    sendSheet () {
      this.loadingSend = true
      utils.postAPI('/people/person_create_in_bulk', this.peopleDataToSend).then(res => {
        console.log(res)
        this.importSheetDialog = false
        this.loadingSend = false
      })
    }
  }
}
</script>
